module.exports = "/images/Mailchimp.svg?13c97db6648c10fc99c718abea7c0036";